import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortClosedForPerformerGrid {
    column: Column;
}

export const focusSelectorSortClosedForPerformerGrid = createAction<
    ActionType,
    FocusSelectorSortClosedForPerformerGrid
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_CLOSED_FOR_PERFORMER_GRID);
